import * as THREE from 'three'
import React, { Suspense, useEffect } from 'react'
import { useLoader } from '@react-three/fiber'
import { useFrame } from '@react-three/fiber'
import { useRef, useState } from 'react'
import { useThree } from "@react-three/fiber";
// import Gallery from "../pages/gallery.tsx";
import { Html } from '@react-three/drei'
import bg from '../assets/screen3/bg.png'
import l1 from '../assets/screen3/21.png'
import l2 from '../assets/screen3/22.png'
import l3 from '../assets/screen1/3.png'
import l4 from '../assets/screen3/24.png'
import l5 from '../assets/screen3/25.png'
import { useVideoTexture, useTexture } from '@react-three/drei'
import Discover from "../assets/screen3/Discover.png";
import img1 from '../assets/Discover/p4.jpg';
import img2 from '../assets/Discover/p64.jpg';
import img3 from '../assets/Discover/p76.jpg';
import img4 from '../assets/Discover/p77.jpg';
import img5 from '../assets/Discover/p81.jpg';


function Layers(data) {
            const texture = useLoader(THREE.TextureLoader, data.imgname)
            const sizes = {
                width: window.innerWidth,
                height: window.innerHeight
            }
            return (
            <mesh position={data.pos}>

                <planeBufferGeometry attach="geometry" args={data.args} />
                <meshBasicMaterial attach="material" map={texture} transparent />
            </mesh>
            )
}


function Scene(props) {
  const ref = useRef()
  const texture = useVideoTexture("/intro1.mp4")
  const [active, setActive] = useState(false)
  const [hovered, setHovered] = useState(false)
  const [args1, setArgs] = useState([5,5]);
  const onClicked = () => {
    setActive(!active)
    if(active){ setPos([108,-3,-18]); setArgs([5,5])}
    else{setPos([115,0,-12]); setArgs([10,5])}
  }
  useFrame(() => {
    if (hovered) {
      ref.current.scale.set(1.1, 1, 1)
    } else {
      ref.current.scale.set(1, 1, 1)
    }
  })
  const [pos , setPos] = useState([108,-5,-18])
    return (
      <mesh ref={ref} position={pos} onClick={(e) => (e.stopPropagation, onClicked())} onPointerMissed = {()=> {setPos([108,-3,-18]) ;setArgs([5,5])}} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>
      <planeGeometry args={args1}/>
        <Suspense fallback={<FallbackMaterial url="/3.png" />}>
          <VideoMaterial url={props.url}  />
          <meshBasicMaterial map={texture} toneMapped={false} />
        </Suspense>
      </mesh>
    )
  }
  function Scene2() {
    const [args1, setArgs] = useState([5,5]);
    const ref = useRef()
    const texture = useVideoTexture("/12.mp4")
    const [active, setActive] = useState(false)
    const [hovered, setHovered] = useState(false)

    const onClicked = () => {
      setActive(!active)
      if(active){ setPos([113,-5,-24]); setArgs([5,5])}
      else{setPos([117,0,-12]);setArgs([5,10])}
    }
    useFrame(() => {
      if (hovered) {
        ref.current.scale.set(1.1, 1, 1)
      } else {
        ref.current.scale.set(1, 1, 1)
      }
    })
    const [pos , setPos] = useState([112,-5,-24])
    return (
      <mesh ref={ref} position={pos} onClick={(e) => (e.stopPropagation, onClicked())} onPointerMissed = {()=> {setPos([113,-3.5,-24]); setArgs([5,5])}} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>
        <planeGeometry args={args1} />
        <Suspense fallback={<FallbackMaterial url="/3.png" />}>
          <VideoMaterial url="/12.mp4"/>
          <meshBasicMaterial map={texture} toneMapped={false}  />
        </Suspense>
      </mesh>
    )
  }
  
  function Scene3() {
    const [args1, setArgs] = useState([5,5]);
    const ref= useRef()
    const texture = useVideoTexture("/intro3.mp4"  )
    const [active, setActive] = useState(false)
    const [hovered, setHovered] = useState(false)

    const onClicked = () => {
      setActive(!active)
      if(active){ setPos([120,-2.5,-15]); setArgs([5,5])}
      else{setPos([120,0,-8]);setArgs([10,5])}
    }
    useFrame(() => {
      if (hovered) {
        ref.current.scale.set(1.1, 1, 1)
      } else {
        ref.current.scale.set(1, 1, 1)
      }
    })
    const [pos , setPos] = useState([120,-3.5,-15])
    return (
      <mesh ref={ref} position={pos} onClick={(e) => (e.stopPropagation, onClicked())} onPointerMissed = {()=> {setPos([120,-2.5,-15]); setArgs([5,5])}} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>
        <planeGeometry args={args1}/>
        <Suspense fallback={<FallbackMaterial url="/3.png" />}>
          <VideoMaterial url="/intro3.mp4" />
          <meshBasicMaterial map={texture} toneMapped={false} />
        </Suspense>
      </mesh>
    )
  }
  function Scene4() {
    const [args1, setArgs] = useState([5,5]);
    const ref= useRef()
    const texture = useVideoTexture("/12.mp4"  )
    const [active, setActive] = useState(false)
    const [hovered, setHovered] = useState(false)

    const onClicked = () => {
      setActive(!active)
      if(active){ setPos([127,-5,-24]); setArgs([5,5])}
      else{setPos([124,0,-8]); setArgs([5,10])}
    }
    useFrame(() => {
      if (hovered) {
        ref.current.scale.set(1.1, 1, 1)
      } else {
        ref.current.scale.set(1, 1, 1)
      }
    })
    const [pos , setPos] = useState([127,-5,-24])
    return (
      <mesh ref={ref} position={pos} onClick={(e) => (e.stopPropagation, onClicked())} onPointerMissed = {()=> {setPos([127,-3.5,-24]); setArgs([5,5])}} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>
        <planeGeometry args={args1}/>
        <Suspense fallback={<FallbackMaterial url="/3.png" />}>
          <VideoMaterial url="/12.mp4" />
          <meshBasicMaterial map={texture} toneMapped={false} />
        </Suspense>
      </mesh>
    )
  }
  
function Images(props){
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
let args1 = props.args;
console.log(sizes)
if(sizes.width < 600){
  args1 = [4,2.25]
  // props.pos = [props.pos[0],props.pos[1],props.pos[2]-5]
}
  const ref = useRef();
    const [args, setArgs] = useState(args1);
    const [pos, setPos] = useState(props.pos);
    // const [active, setActive] = useState(false)
    const [hovered, setHovered] = useState(false)
    const texture = useLoader(THREE.TextureLoader, props.imgname);
    useFrame(() => {
      if (hovered) {
        ref.current.scale.set(1.1, 1, 1)
      } else {
        ref.current.scale.set(1, 1, 1)
      }
    })
    return (
      <mesh ref={ref} position={pos}   onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>

          <planeBufferGeometry attach="geometry" args={args} />
          <meshBasicMaterial attach="material" map={texture} transparent />
      </mesh>
      )
}


  // function Scene5() {
  //   const [args1, setArgs] = useState([5,5]);
  //   const ref= useRef()
  //   const texture = useVideoTexture("/intro2.mp4"  )
  //   const [active, setActive] = useState(false)
  //   const [hovered, setHovered] = useState(false)

  //   const onClicked = () => {
  //     setActive(!active)
  //     if(active){ setPos([132,-3,-18]); setArgs([5,5])}
  //     else{setPos([129,0,-8]); setArgs([10,5])}
  //   }
  //   useFrame(() => {
  //     if (hovered) {
  //       ref.current.scale.set(1.1, 1.1, 1.1)
  //     } else {
  //       ref.current.scale.set(1, 1, 1)
  //     }
  //   })
  //   const [pos , setPos] = useState([132,-5,-18])
  //   return (
  //     <mesh ref={ref} position={pos}  onPointerMissed = {()=> {setPos([132,-3,-18]); setArgs([5,5])}} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>
  //       <planeGeometry args={args1}/>
  //       <Suspense fallback={<FallbackMaterial url="/3.png" />}>
  //         <VideoMaterial url="/intro2.mp4" />
  //         <meshBasicMaterial map={texture} toneMapped={false} />
  //       </Suspense>
  //     </mesh>
  //   )
  // }
  function VideoMaterial({ url }) {
    const texture = useVideoTexture(url)
    return <meshBasicMaterial map={texture} toneMapped={false}  />
  }
  
  function FallbackMaterial({ url }) {
    const texture = useTexture(url)
    return <meshBasicMaterial map={texture} toneMapped={false} />
  }
  
export default function Screen2() {
    return (
        <>
        {/* <Scene url="/intro1.mp4"/>
        <Scene2/>
        <Scene3/>
        <Scene4/>
        <Scene5/> */}
        <Images pos={[114,0,-15]} args={[10,6]} imgname={img1} />
        <Images pos={[125,-4,-15]} args={[10,6]} imgname={img2} />
        <Images pos={[125,1,-15]} args={[6,3]} imgname={img3} />
        <Images pos={[136,0,-15]} args={[10,6]} imgname={img4} />
        <Images pos={[147,-3,-15]} args={[10,6]} imgname={img5} />
            {/* <Layers pos={[120,-0.25,-30]} args={[60,30]} imgname={l5}/> */}
            <Layers pos={[150,0,-60]} args={[216,54]} imgname={bg}/>
            <Layers pos={[120,-5,-55]} args={[70,50]} imgname={l4}/>
            
            <Layers pos={[130,3.5,-15]} args={[10,10]} imgname={Discover}/>
            
             <Layers pos={[110,0,-13]} args={[30,15]} imgname={l2}/>
            <Layers pos={[165,0,-13]} args={[30,15]} imgname={l2}/>
            <Layers pos={[225,0,-13]} args={[30,15]} imgname={l2}/>

            <Layers pos={[120,0,-7]}  args={[20,10]} imgname={l1}/>
            <Layers pos={[140,0,-7]}  args={[20,10]} imgname={l1}/>
            <Layers pos={[160,0,-7]}  args={[20,10]} imgname={l1}/> 
            <Layers pos={[180,0,-7]}  args={[20,10]} imgname={l1}/> 
            <Layers pos={[200,0,-7]}  args={[20,10]} imgname={l1}/> 
        </>
    )
}